import { render, staticRenderFns } from "./SuccessModal.vue?vue&type=template&id=fab9dcc2&scoped=true&"
import script from "./SuccessModal.vue?vue&type=script&lang=js&"
export * from "./SuccessModal.vue?vue&type=script&lang=js&"
import style0 from "./SuccessModal.vue?vue&type=style&index=0&id=fab9dcc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab9dcc2",
  null
  
)

export default component.exports